import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  propertiesContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },

  loadingContainer: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  reproductionInfoContainer: {
    marginTop: 16
  },

  propertiesHeader: {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  title: {
    margin: 0,
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 16
  },

  propertiesTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight
  },

  section: {
    border: '1px solid ' + theme.palette.divider,
    borderRadius: 8,
    padding: 16,
    backgroundColor: theme.palette.background.default
  },

  reproductionDiagnosisLayout: {
    display: 'flex',
    gap: 16,
    alignItems: 'flex-start',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },

  reproductionSection: {
    width: '60%',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  diagnosisSection: {
    width: '40%',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 16,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  sectionTitle: {
    margin: 0,
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500
  },

  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 16,

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },

  singleColumnGrid: {
    gridTemplateColumns: '1fr'
  },

  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minWidth: 0
  },

  infoLabel: {
    fontSize: theme.app.typography.small.fontSize,
    color: theme.app.colors.text.primary
  },

  infoValue: {
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 500,
    color: theme.app.colors.text.primary,
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
  },

  animalHeaderTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },

  genderIcon: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      width: 24,
      height: 24,
      '& path': {
        fill: theme.palette.primary.main
      }
    }
  },

  animalInfoGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginTop: 16
  },

  animalInfoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },

  animalInfoIcon: {
    width: 20,
    height: 20,
    flexShrink: 0,
    '& path': {
      fill: theme.palette.primary.main
    }
  },

  animalInfoContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
    flex: 1
  },

  animalInfoLabel: {
    fontSize: theme.app.typography.label.fontSize,
    color: theme.app.colors.text.secondary,
    fontWeight: 400
  },

  animalInfoValue: {
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 500,
    color: theme.app.colors.text.primary,
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
  },

  formControl: {
    marginBottom: 16,

    [theme.breakpoints.down('sm')]: {
      marginBottom: 0
    }
  },

  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    marginTop: 12,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column'
    }
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: 8,

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: '1px solid ' + theme.palette.primary.main,
    color: theme.palette.primary.main
  },

  secondaryOutlinedField: {
    backgroundColor: 'transparent',
    border: '1px solid ' + theme.palette.primary.main,
    color: theme.palette.primary.main,
    borderRadius: 8,
    fontWeight: 500,
    alignItems: 'center',
    padding: 12
  },

  deliveryDateDesktop: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },

  deliveryDateMobile: {
    display: 'none',
    marginTop: -6,

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      padding: 10
    }
  },

  emptyState: {
    margin: 0,
    fontSize: 14,
    color: theme.palette.text.primary
  },

  diagnosisPendingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 14,
    gap: 12,
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      alignItems: 'center'
    }
  },

  diagnosisPendingHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10
  },

  diagnosisPendingIcon: {
    backgroundColor: theme.palette.primary.main + '15',
    borderRadius: '50%',
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: 4,
    '& svg': {
      color: theme.palette.primary.main,
      fontSize: 24
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: 0
    }
  },

  diagnosisPendingText: {
    margin: 0,
    fontSize: '0.95rem',
    color: theme.app.colors.text.secondary,
    lineHeight: 1.5,
    textAlign: 'center'
  },

  diagnosisInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 14,
    gap: 12
  },

  radioGroupInline: {
    display: 'flex',
    gap: 24,
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 12
    }
  },

  savedBirthCard: {
    border: '1px solid ' + theme.palette.divider,
    borderRadius: 8,
    padding: 12,
    backgroundColor: theme.palette.background.default
  },

  savedBirthTitle: {
    margin: '0 0 10px 0',
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 500
  },

  pendingDiagnosisContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: '32px 16px',
    textAlign: 'center'
  },

  pendingDiagnosisContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12
  },

  pendingDiagnosisIcon: {
    fontSize: 42,
    color: theme.palette.primary.main
  },

  pendingDiagnosisText: {
    fontSize: 16,
    color: theme.palette.grey[600],
    fontWeight: 500
  }
}))
